module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "align-center",
    class: {
      toggled: _vm.menuToggled
    },
    attrs: {
      "id": "header"
    },
    on: {
      "click": function($event) {
        _vm.menuToggled = false
      }
    }
  }, [_c('div', [_c('header', {
    on: {
      "click": function($event) {
        _vm.menuToggled = false
      }
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon.svg",
      "alt": "Campbell School of Highland Dance"
    }
  })])], 1)]), _vm._v(" "), _c('aside', {
    staticClass: "heading",
    attrs: {
      "title": "Campbell School of Highland Dance"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("CSHD")])], 1), _vm._v(" "), _c('nav', [_c('router-link', {
    attrs: {
      "to": "/#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/#schedule"
    }
  }, [_vm._v("Registration")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('EnrollButton'), _vm._v(" "), _c('label', {
    staticClass: "selectable"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleCountryChange]
    }
  }, _vm._l((_vm.countries), function(info, code) {
    return _c('option', {
      key: code,
      domProps: {
        "value": code
      }
    }, [_vm._v(_vm._s(info.flag))])
  }), 0)])], 1), _vm._v(" "), _c('footer', [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.menuToggled = !_vm.menuToggled
      }
    }
  }, [_c('i', [_vm._v("Menu")])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "align-center",
    attrs: {
      "id": "footer"
    }
  }, [_c('header', [_c('div', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Campbell School of Highland Dance")]), _vm._v("  •  2016–" + _vm._s(_vm.year))], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8626f728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 106
// module chunks = 1